module.exports = __webpack_public_path__ + "media/assets/images/landing/logo_about_1-0c68af0dd7c55de4a6f3c3723e4a5b00.png";